//import Behome from "./containers/BeHome";
import { HistoricReleaseTable } from "./HistoricRelease";

const BeWork = {
  HistoricReleaseTable,
};

export { BeWork };
